import axiosDefault from "axios";
import config from "../config";

const isProduction = process.env.NODE_ENV === "production";

// Exported the baseURL so we can reference it elsewhere, but we might want to think about moving this...

const defaultOptions = {
  baseURL: config.apiBaseUrl,
  withCredentials:true,
  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': config.axiosOrigin,
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
  },
};

const axios = axiosDefault.create(defaultOptions);
axios.defaults.withCredentials = true;

// Add request interceptor to log all requests for debugging
axios.interceptors.request.use(
  config => {
    console.log(`API Request: ${config.method.toUpperCase()} ${config.url}`, config.params || {});
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor to log all responses for debugging
axios.interceptors.response.use(
  response => {
    console.log(`API Response: ${response.status} ${response.config.url}`, response.data);
    return response;
  },
  error => {
    console.error(`API Error: ${error.response?.status || 'Network Error'} ${error.config?.url || 'Unknown URL'}`, 
      error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axios;
